import React, { PropTypes } from 'react';
import Helmet from 'react-helmet';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames';

import Modal from './../components/Modals/Modal';

// Container Components
import Content from './Content';
import Navbar from './Navbar';
import Tools from './Tools';

// actions
import * as actions from './../actions/actions';

class Root extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { mode, templates, templateActive } = this.props;
        const contentCss = classNames({
            root: true,
            'root-fullpage': mode !== 'EDIT',
            'root-fullpage-client': mode === 'CLIENT',
            'root-fullpage-preview': mode === 'PREVIEW',
        });
        return (
            <div className={contentCss}>
                <Helmet title="My Title" link={[{ rel: 'stylesheet', href: templates[templateActive].css }]} />
                <div className="header" />
                { (mode === 'EDIT') ? <Navbar /> : <div /> }
                <Content />
                { (mode === 'EDIT') ? <Tools /> : <div /> }
                <Modal />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    mode: state.app.mode,
    templates: state.templates,
    templateActive: state.app.template,
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
});

Root.propTypes = {
    mode: PropTypes.string.isRequired,
    templateActive: PropTypes.number.isRequired,
    templates: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Root);




// WEBPACK FOOTER //
// ./src/_app/quick_response/containers/_Root.jsx